import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";

import { ZERO_RESULT_SEARCH_CACHE_KEYS } from "./keys";

import { ZeroResultSearchRepository } from "@/repositories/zero-result-search";

export const useGetZeroResultEvents = (
  queryId: string,
  page = 1,
  limit = 10,
  enabled = true,
) => {
  const repository = useRef(new ZeroResultSearchRepository());

  return useQuery({
    queryKey: ZERO_RESULT_SEARCH_CACHE_KEYS.EVENTS(queryId, page, limit),
    queryFn: async () => {
      return await repository.current.findEvents(queryId, page, limit);
    },
    placeholderData: keepPreviousData,
    enabled,
  });
};
